import { Music2, Instagram, Newspaper, MessageSquare, Twitter } from "lucide-react";

type Channel = {
  label: string;
  icon: typeof Music2;
  status: "live" | "soon";
};

const CHANNELS: Channel[] = [
  { label: "TikTok", icon: Music2, status: "live" },
  { label: "Instagram", icon: Instagram, status: "soon" },
  { label: "X", icon: Twitter, status: "soon" },
  { label: "Local News", icon: Newspaper, status: "soon" },
  { label: "Community Posts", icon: MessageSquare, status: "soon" },
];

interface SignalChannelsProps {
  size?: "sm" | "md";
  className?: string;
}

const SignalChannels = ({ size = "md", className = "" }: SignalChannelsProps) => {
  const padding = size === "sm" ? "px-2.5 py-1" : "px-3 py-1.5";
  const text = size === "sm" ? "text-[11px]" : "text-xs";
  const iconSize = size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5";

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {CHANNELS.map(({ label, icon: Icon, status }) => (
        <span
          key={label}
          className={`inline-flex items-center gap-1.5 rounded-full border ${padding} ${text} font-medium transition-colors ${
            status === "live"
              ? "border-primary/40 bg-primary/10 text-primary"
              : "border-border bg-card/40 text-muted-foreground"
          }`}
        >
          <Icon className={iconSize} />
          {label}
          <span
            className={`ml-1 text-[9px] uppercase tracking-wider ${
              status === "live" ? "text-primary/80" : "text-muted-foreground/70"
            }`}
          >
            {status === "live" ? "Live" : "Soon"}
          </span>
        </span>
      ))}
    </div>
  );
};

export default SignalChannels;